import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function Spinner({ isShowSpinner }) {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isShowSpinner}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default Spinner;
